export default __webpack_public_path__ + "static/media/09_Mask.0f8bf6cb.mp4";